import { render, staticRenderFns } from "./AssignGroupsToStudents.vue?vue&type=template&id=44f00734"
import script from "./AssignGroupsToStudents.vue?vue&type=script&lang=js"
export * from "./AssignGroupsToStudents.vue?vue&type=script&lang=js"
import style0 from "./AssignGroupsToStudents.vue?vue&type=style&index=0&id=44f00734&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f00734')) {
      api.createRecord('44f00734', component.options)
    } else {
      api.reload('44f00734', component.options)
    }
    module.hot.accept("./AssignGroupsToStudents.vue?vue&type=template&id=44f00734", function () {
      api.rerender('44f00734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AssignGroupsToStudents.vue"
export default component.exports